export default __webpack_public_path__ + "static/google-play-badge-0519f38b7424c50a181d24da3b8e30d8.png";